import { useSuspenseInfiniteQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { disciplineClient } from '../client/disciplineClient';

type Options = {
};

const defaultOptions: Partial<Options> = {
};

const defaultPageSize = 10;

export const useInfiniteDisciplines = (params: Disciplines.GetListParams = {}, options: Partial<Options> = defaultOptions) => {
  
  const {
    data,
    ...rest
  } = useSuspenseInfiniteQuery({
    queryKey: [cacheKeys.getDisciplines, Object.values(params)],
    queryFn: ({ pageParam }) => disciplineClient.getDisciplines({
      ...params,
      limit: params.limit || defaultPageSize,
      offset: (pageParam - 1) * defaultPageSize,
    }),
    initialPageParam: 1,
    ...options,
    getNextPageParam: (lastPage, allPages) => {
      const totalPages = Math.ceil((lastPage?.data.count || 0) / (params.limit || defaultPageSize));
      const currentPage = allPages.length;
      if (currentPage < totalPages) {
        return currentPage + 1;
      }
      return undefined;
    },
  });

  const count = data?.pages[data.pages.length - 1]?.data?.count || 0;

  const disciplines = data?.pages.flatMap(page => page.data?.results || []) || [];

  return {
    ...rest,
    count,
    disciplines,
  };
};
